/**
 * Variants have stories, this compoent does not need one.
 */
/* eslint-disable local-rules/require-storybook-documentation */
import dynamic from 'next/dynamic';
import { FC } from 'react';
import {
    ZHLPersonalizedNextStepExperience,
    ZHLPersonalizedNextStepState,
} from 'src/services/graphql/generated/graphql';

const DefaultViewSavedInformation = dynamic(() =>
    import(
        /* webpackChunkName: "DefaultViewSavedInformation" */
        './experiences/DefaultViewSavedInformation'
    ).then(mod => mod.DefaultViewSavedInformation)
);

export type ViewSavedInformationModuleProps = {
    /**
     * What PNS status experience to show
     */
    status: ZHLPersonalizedNextStepState | null;
    /**
     * Callback for when the user clicks on the View Saved Information CTA
     */
    onCTAClick: () => void;
    /**
     * Analytics Callback
     */
    trackCTAClick: () => void;
    /**
     * What PNS experience to show
     */
    experience: ZHLPersonalizedNextStepExperience | null;
};

/**
 * This component is a micro-frontend module that renders a View Saved Information card with a CTA
 * that brings the user back to Blend
 */
export const ViewSavedInformation: FC<ViewSavedInformationModuleProps> = ({
    onCTAClick,
    status,
    trackCTAClick,
    experience,
}) => {
    if (!status) {
        return null;
    }
    if (experience === ZHLPersonalizedNextStepExperience.FIRST_PARTY) {
        return null;
    }
    return <DefaultViewSavedInformation onCTAClick={onCTAClick} trackCTAClick={trackCTAClick} />;
};
